import React from 'react';

import { TileInfo } from 'app/home/index.functions';
import { ReportingToolIcon } from './ReportingToolIcon';
import { Stack } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';

export const ReportToolSectionMultiLine = function ({
    style,
    tile,
    tileicons,
}: {
    style?: any;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
}) {
    const defaultStyle = {};

    return (
        <Stack
            direction={'row'}
            alignItems={'center'}
            sx={{ width: '18px', height: '18px', color: 'primary.main', mr: 1, img: { mr: '0px !important' } }}
            style={{ ...style, ...defaultStyle }}
            className={'tile-element__report-tool'}
        >
            {['external report'].includes(tile.element_type || '') && (
                <>
                    {ReportingToolIcon(tileicons, tile.reporting_tool_name || '') ?? (
                        <IconMi icon={'external-report'} sx={{ fontSize: '16px' }} />
                    )}
                </>
            )}
            {['other external content'].includes(tile.element_type || '') && (
                <>
                    {ReportingToolIcon(tileicons, tile.external_content_type_name || '') ?? (
                        <IconMi icon={'external-content'} sx={{ fontSize: '16px' }} />
                    )}
                </>
            )}
            {['metric'].includes(tile.element_type || '') && <IconMi icon={'metric'} sx={{ fontSize: '15px' }} />}
            {['internal report'].includes(tile.element_type || '') && (
                <IconMi icon={'report'} sx={{ fontSize: '16px' }} />
            )}
        </Stack>
    );
};
